const scrollToSection = (e, id) => {
  e.preventDefault();
  let elem = document.getElementById(id);
  if (elem) {
    elem.scrollIntoView();
  }
};

export { scrollToSection };
